export default __webpack_public_path__ + "static/media/Checked.e6f672f6.svg";